import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Skeleton } from '@material-ui/lab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Search } from 'styled-icons/boxicons-regular';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { startShowApplicants } from '../../redux/actions/_initializer_actions';
import { palette } from '../../system/styles/styles';
// import {builderSearchPostulations} from "../../redux/actions/_applications_actions";
import { ApplicationsContainer } from '../../system/styles/views/applications';
import ExportExcelApplications from '../../components/applications/exportExcel';

const Applications = (props) => {
  const { className } = props;

  const dispatch = useDispatch();
  const platform = useSelector((state) => state.platform);
  const users = useSelector((state) => state.applicants);
  const [dataPostulations, setDataPostulations] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  // const open = useSelector((state) => state.elementary.loadPostulations);

  const [search, setSearch] = React.useState('');
  const [order, setOrder] = React.useState('desc');
  const searchInFauna = () => {
    //Se inicia el loading para mostrar elemento de carga
    setLoading(true);
    let dataLocal = users.sort((a, b) => {
      if (a.time > b.time) {
        return 1;
      }
      if (a.time < b.time) {
        return -1;
      }
      return 0;
    });
    if (search) {
      dataLocal = dataLocal?.filter((user) => {
        return (
          user?.names?.toLowerCase()?.includes(search?.toLowerCase()) ||
          user?.email?.toLowerCase()?.includes(search?.toLowerCase())
        );
      });
    }
    if (order === 'asc') {
      dataLocal = dataLocal?.reverse();
    }
    setDataPostulations(dataLocal);
    //Se termina el loading y se muestra la respuesta
    setLoading(false);
  };

  React.useEffect(() => {
    if (!users.length) {
      dispatch(startShowApplicants());
    }
  }, []);
  //Se utiliza user.length para evitar un loop al no haber datos
  React.useEffect(() => {
    searchInFauna();
  }, [order, users.length]);

  return (
    <ApplicationsContainer adminColor={platform?.adminColor} className={className}>
      <div className="heading">
        <h1 className="title">Historial de postulaciones</h1>
        <div className="headingFilters">
          <div>
            <label>Nombre / Email:</label>
            <input
              type="text"
              value={search}
              onChange={({ target }) => setSearch(target.value)}
              placeholder="Carlos / ejemplo@lapieza.io"
            />
            <button type="button" onClick={searchInFauna}>
              <Search size={20} color="#FFF" />
            </button>
          </div>
          <div>
            <label>Ordenar:</label>
            <select name="order" id="order" value={order} onChange={({ target }) => setOrder(target.value)}>
              <option value="desc">Más nuevo primero</option>
              <option value="asc">Más viejo primero</option>
            </select>
          </div>
          <ExportExcelApplications dataGeneral={dataPostulations} />
        </div>
      </div>
      <TableContainer>
        <Table
          stickyHeader
          className="applicationsPage"
          style={{ background: '#fff', marginTop: -64, padding: 8, overflow: 'auto' }}>
          <TableHead className="listTitles">
            <TableRow>
              <TableCell className="listTitles">Nombre</TableCell>
              <TableCell className="listTitles">Vacante</TableCell>
              <TableCell className="listTitles">Fecha</TableCell>
              <TableCell className="listTitles">Correo</TableCell>
            </TableRow>
          </TableHead>
          {users.length > 0 && dataPostulations.length > 0 && !loading ? (
            <TableBody>
              {dataPostulations.map((element, index) => {
                return (
                  <TableRow className="listItem" key={index?.toString()}>
                    <TableCell>
                      <p className="listName">{`${element.names || element?.name} ${element.lastNames}`}</p>
                    </TableCell>
                    <TableCell className="listName">
                      <p className="listVacancy">
                        {element.jobName} <br /> {element.companyName}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p className="listName">{dayjs(element.time).format('DD / MMM / YYYY')}</p>
                    </TableCell>
                    <TableCell>
                      <p className="listName">{element.email}</p>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          ) : loading ? (
            <>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" />
                </TableCell>
              </TableRow>
            </>
          ) : (
            <h2>No hay postulaciones</h2>
          )}
        </Table>
      </TableContainer>
    </ApplicationsContainer>
  );
};

Applications.propTypes = {
  className: PropTypes.bool,
};

Applications.defaultProps = {
  className: '',
};
export default Applications;
